import { tv } from '~/utils/tv'

export const ratingVariants = tv({
  base: `
    flex flex-row bg-[transparent]
  `,
  variants: {
    size: {
      tiny: 'gap-none',
      small: 'gap-onepulse',
    },
  },
})
